<div class="specific-container">
    <div class="bckp-policies-policy-name">{{ item.result.policyName }}</div>
    <div class="bckp-policies-servers overflow-ellipsis">
        {{item.result.serversShortList}}
    </div>
    <div class="bckp-policies-master">{{ item.result.master }}</div>
    <div class="bckp-policies-policy-type">{{ item.result.policyType }}</div>
</div>
